module.exports = __webpack_public_path__ + "img/save-money-inactive.989f9a98.png";